<template>
  <div>
    <!-- <pre>{{assignment_data_list}}</pre> -->
    <!-- <pre>{{assignment_subjects}}</pre> -->
    <vs-collapse class="new_cstm_collapse_holder">
      <vs-collapse-item
        v-for="(assignment, subject) in assignment_subjects"
        :key="subject"
      >
        <div slot="header">{{ subject }}</div>

        <vs-table class="cstm_vuexy_table" :data="assignment.filter((ele) => ele.curriculum_details)">
          <template slot="thead">
            <vs-th> Name </vs-th>
            <vs-th style="min-width: 160px"> Description </vs-th>
            <!-- <vs-th> Subject </vs-th> -->
            <vs-th style="min-width: 120px"> No. of Topics </vs-th>
            <vs-th style="min-width: 110px"> No. of Files </vs-th>
            <vs-th> Tags </vs-th>
            <vs-th v-if="edit_permission()">Remove</vs-th>
          </template>

          <template slot-scope="{ data }">
            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td>
                {{ data[indextr].curriculum_details.name }}
              </vs-td>
              <vs-td>
                {{ data[indextr].curriculum_details.description }}
              </vs-td>

              <!-- <vs-td>
                <span
                  v-for="(subject, index) in data[indextr].curriculum_details
                    .subjects"
                  :key="index"
                >
                  {{ subject.subject.subject_name }}
                  <span
                    v-if="
                      index + 1 < data[indextr].curriculum_details.subjects.length
                    "
                    >,
                  </span>
                </span>
              </vs-td> -->

              <vs-td>
                {{ data[indextr].curriculum_details.lessonTopics.length }}
              </vs-td>

              <vs-td>
                {{ data[indextr].curriculum_details.lessonFiles.length }}
              </vs-td>

              <vs-td>
                <span
                  v-for="(tag, tagindex) in data[indextr].curriculum_details
                    .lessonTags"
                  :key="tagindex"
                >
                  {{ tag.tag.name }}
                  <span
                    v-if="
                      tagindex + 1 <
                      data[indextr].curriculum_details.lessonTags.length
                    "
                    >,
                  </span>
                </span>
              </vs-td>

              <vs-td v-if="edit_permission()">
                <vs-button
                  color="danger"
                  type="border"
                  icon="delete"
                  @click="removeAlert(data[indextr].curriculum_id)"
                ></vs-button>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </vs-collapse-item>
    </vs-collapse>
  </div>
</template>

<script>
export default {
  props: {
    assignment_data_list: {},
    edit_permission: {
      type: Function
    }
  },
  data () {
    return {
      assignment_subjects: null
    }
  },
  watch: {
    assignment_data_list () {
      console.log('watched')
      this.groupItems()
    }
  },
  mounted () {
    this.groupItems()
  },
  methods: {
    groupItems () {
      //console.log('here', this.assignment_data_list)
      // eslint-disable-next-line no-undef
      this.assignment_subjects = _.groupBy(
        this.assignment_data_list,
        (subject) => subject.curriculum_details.subjects[0].subject.subject_name
      )
      console.log('sub', this.assignment_subjects)
    },
    removeAlert (id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Please Confirm',
        text: 'Are you sure you want to delete this file?',
        accept: this.acceptAlert,
        parameters: id
      })
    },
    acceptAlert (id) {
      const delete_ids = [id]
      console.log(delete_ids)
      this.$emit('deleteCurricullum', delete_ids)
      console.log(id)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>